import { ReactElement } from 'react';

import { DashboardVariantV2GiverContentActionsContainer } from '../../../../styles';

import DashboardVariantV2GiverContentInPreparationTabActionsFilters from './Filters';
import DashboardVariantV2GiverContentInPreparationTabActionsActionables from './Actionables';

const DashboardVariantV2GiverContentInPreparationTabActions =
  (): ReactElement => {
    return (
      <DashboardVariantV2GiverContentActionsContainer justifyContent="space-between">
        <DashboardVariantV2GiverContentInPreparationTabActionsFilters />

        <DashboardVariantV2GiverContentInPreparationTabActionsActionables />
      </DashboardVariantV2GiverContentActionsContainer>
    );
  };

export default DashboardVariantV2GiverContentInPreparationTabActions;
